import { put, select, takeLatest } from 'redux-saga/effects'
import * as actions from '../store/vitals.actions'
import { VitalsConstants } from '../store/vitals.constants'
import { IPatientVitals } from '../store/vitals.types'
import { getPatientVitalsSelector } from '../selectors/patientVitals.selector'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'

export function* setTotalApgarScore() {
  try {
    const patientVital: IPatientVitals = yield select(getPatientVitalsSelector)

    const { apgarAppearance, apgarPulse, apgarGrimace, apgarActivity, apgarRespiration } = patientVital

    // Sum all component scores, treating null/undefined as 0
    const totalScore =
      (Number(apgarAppearance?.id) || 0) +
      (Number(apgarPulse?.id) || 0) +
      (Number(apgarGrimace?.id) || 0) +
      (Number(apgarActivity?.id) || 0) +
      (Number(apgarRespiration?.id) || 0)

    const apgar = [
      apgarAppearance?.id || '',
      apgarPulse?.id || '',
      apgarGrimace?.id || '',
      apgarActivity?.id || '',
      apgarRespiration?.id || '',
    ].join(',')

    yield put(actions.setTotalApgarScore(totalScore.toString()))
    yield put(actions.setApgar(apgar))
  } catch (e) {
    yield put(throwPcrException(`setTotalApgarScore() error: ${e}`))
  }
}

export function* setTotalApgarScoreSaga() {
  yield takeLatest(
    [
      VitalsConstants.SET_APGAR_APPEARANCE,
      VitalsConstants.SET_APGAR_PULSE,
      VitalsConstants.SET_APGAR_GRIMACE,
      VitalsConstants.SET_APGAR_ACTIVITY,
      VitalsConstants.SET_APGAR_RESPIRATION,
    ],
    performWithMutexHOG,
    setTotalApgarScore
  )
}
